import SearchParamsBase from '../../../Elements/SearchParamsBase';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import AuthService from '../../../Services/authService';

export default class UnappliedPrepaymentReportSearchParams extends SearchParamsBase {
  static saveType = 'UnappliedPrepaymentReportSearchParams';
  initialize() {
    this.OfficeIds = UnappliedPrepaymentReportSearchParams.getUserOffice();
    this.ClientIds = [];
  }

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return OfficeHelper.GetDefaultOfficeIds(user.officeId);
  }
}
